import axios from 'axios';
import { CONFIGS, KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from './Constants/constant';
import { captureException } from '@sentry/react';
export let axiosInstance;

export const getAxiosInstance = () => {
  axiosInstance = axios.create({
    // baseURL: CONFIGS.BASE_URL,
    baseURL: 'https://iimu-faculty-api-prod.thekenverse.com', 
    timeout: 25000,
  });

  axiosInstance.interceptors.request.use((req) => {
    req.headers.Authorization = `Bearer ${localStorage.getItem(KEY_ACCESS_TOKEN)}`;
    req.headers['access-token'] = localStorage.getItem(KEY_ACCESS_TOKEN);
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      captureException(error);
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }

      if (error.response?.status === 400 || error.response?.status === 404 || error.response?.status === 500) {
        return error;
      }

      if (localStorage.refresh_token && (error.response.status === 402 || error.response.status === 502 || error?.response?.data?.error_code == 'jwt_token_expired')) {
        // const url = CONFIGS.REFRESH_URL;
        const url = 'https://iimu-faculty-api-prod.thekenverse.com/api/app/refreshToken';
        try {
          const res = await axios.post(url, {
            refreshToken: localStorage.refresh_token,
          });
          localStorage.setItem(KEY_ACCESS_TOKEN, res?.data?.accessToken?.token);
          localStorage.setItem(KEY_REFRESH_TOKEN, res?.data?.refreshToken?.token);
          error.response.config.headers['Authorization'] = `Bearer ${res?.data?.accessToken?.token}`;
          error.response.config.headers['access-token'] = localStorage.getItem(KEY_ACCESS_TOKEN);
          return axios(error.response.config);
        } catch (err) {
          localStorage.clear();
          window.location.reload();
        }
      } else {
        captureException(error);
        localStorage.clear();
        window.location.reload();
        return axios(error.response.config);
      }
    }
  );
};

export const razorpayInitiate = async (data) => {
  const path = `/v1/razorpay/initiate`;
  const response = await axiosInstance.post(`${path}`, data);
  return response && response.data ? response.data : null;
};

export const verifyRazorpay = async (order_id, razorpay_payment_id, razorpay_signature, date) => {
  const path = `/v1/razorpay/verifyOrderSuccess?order_id=${order_id}&razorpay_payment_id=${razorpay_payment_id}&razorpay_signature=${razorpay_signature}`;
  const response = await axiosInstance.get(`${path}`);
  return response && response.data ? response.data : null;
};

export const getAllPrograms = async (applicantId) => {
  const path = `v1/forms/getAllForms`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFormByFormId = async (formId) => {
  const path = `v1/forms/getFormsById?id=${formId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicationsByApplicantId = async (applicantid) => {
  const path = `/v1/application/getAllApplications?applicantid=${applicantid}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicationByApplicationId = async (applicationId) => {
  const path = `/v1/application/getApplication?applicationid=${applicationId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createUpdateApplication = async (data) => {
  const path = `/v1/application/portal/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res;
};

export const deleteApplicationRecords = async (type, id) => {
  const path = `/v1/application/portal/delete?type=${type}&id=${id}`;
  const res = await axiosInstance.delete(`${path}`);
  return res && res.data ? res.data : null;
};

export const employmentRecords = async () => {
  const path = `/v1/application/employment/records`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getDocuments = async (applicantId) => {
  const path = `/v1/application/documents?applicantId=${applicantId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createDocuments = async (data) => {
  const path = '/v1/application/portal/save';
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getDocumentUrl = async (formData, appId) => {
  const path = `/v1/application/upload/${appId}/document`;
  const res = await axiosInstance.post(`${path}`, formData);
  return res && res.data ? res.data : null;
};

export const getFeeDetails = async (applicationId) => {
  const path = `/v1/application/feeAssignmentId/${applicationId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};
// export const getDownlaodReceipt = async (receiptId) => {
//   const path = `/v1/application/downloadPaymentReceipt/${receiptId}`;
//   const res = await axiosInstance.get(`${path}`);
//   return res && res.data ? res.data : null;
// };
export const getDownlaodReceipt = async (receiptId) => {
  const path = `/v1/application/downloadPaymentReceipt/${receiptId}`;
  const res = await axiosInstance.get(path, {
    responseType: 'arraybuffer',
  });
  return res;
};

export const getApplicationPreviewPdf = async (applicationId) => {
  const path = `/v1/application/preview/pdf?applicantId=${applicationId}`;
  const res = await axiosInstance.get(`${path}`, {
    responseType: 'arraybuffer',
  });
  return res;
};

export const postInitatePayment = async (data) => {
  const path = `payments/flywire/initiate`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getPaymentTransactions = async (applicantId) => {
  const path = `/v1/application/transactions?applicantId=${applicantId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createEMBAToken = async (id) => {
  const path = `/v1/application/createtoken/emba`;
  const res = await axiosInstance.get(`${path}?id=${id}`);
  return res && res.data ? res.data : null;
};

export const verifyEMBAToken = async (token, appId, expiry) => {
  const path = `/v1/application/verifytoken/emba?token=${token}&appId=${appId}&tokenExpiry=${expiry}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const updateLead = async (data) => {
  const path = `update/lead?contact=${data}`;
  const res = await axiosInstance.post(`${path}`);
  return res && res.data ? res.data : null;
};

// create lead
export const createLead = async (data) => {
  try {
    const path = `v1/lead/create`;
    const res = await axiosInstance.post(`${path}`, data);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    console.log(error, 'error');
    return error;
  }
};

export const getLeadDetails = async (email) => {
  try {
    console.log(email, 'email');
    const path = '/v1/lead/get/details';
    const res = await axiosInstance.get(`${path}?email=${email}`);
    console.log(res, 'dataRes');
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    console.log(error, 'error');
    return error;
  }
};

// Verification Lead
export const verificationLead = async (token) => {
  try {
    const path = `v1/lead/verification?token=${token}`;
    const res = await axiosInstance.get(`${path}`);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    console.log(error, 'error');
    return error;
  }
};

export const authenticateEmailPasswordLead = async (payload) => {
  const path = `v1/lead/authenticate`;
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const authenticateByEmailLead = async (payload) => {
  const path = `/v1/login/send/otp`; // TBD: API to be integrated
  const res = await axiosInstance.post(`${path}?email=${payload}`);
  return res && res.data ? res.data : null;
};

export const otpVerify = async (payload) => {
  try {
    const path = `v1/login/otp/verify?email=${payload.email}&otpentered=${payload.otp}`;
    const res = await axiosInstance.get(`${path}`);
    return res && res.data ? res.data : null;
  } catch (error) {
    console.log(error, 'error');
    return error;
  }
};

export const forgotPassword = async (email) => {
  const path = `v1/lead/forgot/password`;
  const res = await axiosInstance.post(`${path}?email=${email}`);
  return res && res.data ? res.data : null;
};

export const resendVerificationLink = async (email) => {
  const path = `v1/lead/resend/verification`;
  const res = await axiosInstance.post(`${path}?email=${email}`);
  return res && res.data ? res.data : null;
};

export const resetPassword = async (payload) => {
  const path = `v1/lead/reset/password`;
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const postcreateCase = async (data) => {
  const path = `/v1/query/create`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};
export const getAllQueryByApplicantId = async (applicantid) => {
  const path = `/v1/query/getAllQuery?applicantid=${applicantid}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};
export const postopenNotification = async (data) => {
  try {
    const path = `v1/query/openNotification`;
    const res = await axiosInstance.post(`${path}`, data);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    console.log(error, 'error');
    return error;
  }
};

export const pendingEvaluation = async (applicantId) => {
  try {
    const path = `v1/interview/pending/evaluation?contactId=${applicantId}`;
    const res = await axiosInstance.get(`${path}`);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    return error;
  }
}

export const completedEvaluation = async (applicantId) => {
  try {
    const path = `v1/interview/completed/evaluation?contactId=${applicantId}`;
    const res = await axiosInstance.get(`${path}`);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    return error;
  }
}

export const evaluationDocument = async (applicantId) => {
  try {
    const path = `v1/interview/evaluation/document?applicationId=${applicantId}`;
    const res = await axiosInstance.get(`${path}`);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    return error;
  }
}

export const evaluationParameter = async (applicationId, reviewerId) => {
  try {
    const path = `v1/interview/evaluation/parameter?applicationId=${applicationId}&reviewerId=${reviewerId}`;
    const res = await axiosInstance.get(`${path}`);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    return error;
  }
}

export const saveEvaluation = async (body) => {
  try {
    const path = 'v1/interview/evaluation';
    const res = await axiosInstance.post(`${path}`, body);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch (error) {
    return error;
  }
}

export const getSlots = async (applicationFormId) => {
  try {
    const path = 'v1/interview/get/slots';
    const res = await axiosInstance.get(`${path}?applicationFormId=a0XC1000000ogiRMAQ`);
    console.log(res, "DatResd");
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch(error) {
    return error;
  }
}

export const updateSlots = async (body) => {
  try {
    const path = 'v1/interview/interviewslot';
    const res = await axiosInstance.post(`${path}`, body);
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch(error) {
    return error;
  }
}

export const viewProfile = async (applicationId) => {
  try {
    const path = `v1/interview/get/application/${applicationId}`;
    const res = await axiosInstance.get(`${path}`, {
      responseType: "blob",
      validateStatus: () => true,
    });
    if (res && res.data) {
      return { success: true, data: res.data };
    } else {
      return { success: false, error: res?.response };
    }
  } catch(error) {
    return error;
  }
}
